import React from "react";
import { Flex } from "@chakra-ui/react";
import { MdCheck } from "react-icons/md";

const ColorPicker = ({ colors, selectColor, value }) => {
  return (
    <Flex
      w="100%"
      flexWrap={"wrap"}
      justifyContent={{
        base: "center",
        md: "flex-start",
      }}
    >
      {colors.map((color, index) => (
        <Flex
          onClick={() => selectColor(color)}
          key={color}
          opacity={value === color ? 1 : 0.3}
          m="10px"
          h="80px"
          w="80px"
          bg={color}
          borderRadius="10px"
          cursor="pointer"
          boxShadow="xl"
          transform={value === color ? "scale(1.1)" : "scale(1)"}
          borderwidth={value === color ? "1px" : "0px"}
          _hover={{
            transform: "scale(1.1)",
            borderWidth: "1px",
          }}
          position="relative"
        >
          {value === color && (
            <Flex
              flex={1}
              alignItems="center"
              justifyContent={"center"}
              fontSize="2em"
            >
              <MdCheck color="white" />
            </Flex>
          )}
        </Flex>
      ))}
    </Flex>
  );
};

export default ColorPicker;
